'use client'

import type { PolarisTypesAccount } from '@polaris/api-client'
import { getWalletColor, hexToRgba } from '@polaris/core/utils'
import { cn } from '@/src/utils/styles'
import { ListRowImage } from '../ui/list-row'
import { WatchAddressIcon } from './watch-address'

interface WalletIconProps {
  logoUrl?: string
  walletName?: string
  walletType?: PolarisTypesAccount['type']
  size?: number
  className?: string
  imageClassName?: string
}

export function WalletIcon({
  logoUrl,
  walletName,
  walletType,
  size = 40,
  className,
  imageClassName,
}: WalletIconProps) {
  const walletColor = getWalletColor(walletName ?? '', walletType)
  const backgroundColor = hexToRgba(walletColor, 0.6)
  const imageSize = Math.max(8, Math.floor(size * 0.8))

  return (
    <div
      className={cn(
        'rounded-[6px] flex items-center justify-center shrink-0',
        className,
      )}
      style={{ width: size, height: size, backgroundColor }}
    >
      {logoUrl === 'no-logo' ? (
        <WatchAddressIcon />
      ) : logoUrl ? (
        <ListRowImage
          src={logoUrl}
          alt={`${walletName ?? 'Wallet'} icon`}
          width={imageSize}
          height={imageSize}
          className={cn('!rounded-sm opacity-60', imageClassName)}
          classes={{ container: 'flex-shrink-0' }}
          unoptimized
          placeholderName={walletName}
        />
      ) : null}
    </div>
  )
}
